import { TwStyle } from 'twin.macro';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';

import { IconButton } from '@restworld/ui-ds';

function BackButton({ onClick, twStyle }: BackButtonProps) {
  const { t } = useTranslation('common');

  return <IconButton ariaLabel={t('go_back')} Icon={ArrowLeftIcon} onClick={onClick} twStyle={twStyle} />;
}
export default BackButton;

interface BackButtonProps {
  onClick?: () => void;
  twStyle?: TwStyle;
}
